// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"320":"c3d160e1a9c8f85a38b6","421":"fc6440afee8cafd5df72","661":"89a9cde40cd971eb5482"}[chunkId] + ".js";
};